(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialize(section) {
    if (section.dataset.comingSoonInitialized === 'true') return;
    section.dataset.comingSoonInitialized = 'true';

    const countdown = section.querySelector('[data-coming-countdown]');
    const launchDate = countdown?.dataset.launchDate;
    if (countdown && launchDate) {
      const target = new Date(launchDate).getTime();
      const fields = {
        days: countdown.querySelector('[data-days]'),
        hours: countdown.querySelector('[data-hours]'),
        minutes: countdown.querySelector('[data-minutes]'),
        seconds: countdown.querySelector('[data-seconds]')
      };
      const update = () => {
        const remaining = Math.max(0, target - Date.now());
        fields.days.textContent = String(Math.floor(remaining / 86400000));
        fields.hours.textContent = String(Math.floor(remaining / 3600000) % 24).padStart(2, '0');
        fields.minutes.textContent = String(Math.floor(remaining / 60000) % 60).padStart(2, '0');
        fields.seconds.textContent = String(Math.floor(remaining / 1000) % 60).padStart(2, '0');
        if (remaining === 0) window.clearInterval(timer);
      };
      const timer = window.setInterval(update, 1000);
      update();
    }

    if (section.dataset.halloweenEffect !== 'true') return;
    section.addEventListener('click', (event) => {
      const button = event.target.closest('[data-coming-action]');
      if (!button || reducedMotion.matches) return;
      const bounds = button.getBoundingClientRect();
      const originX = bounds.left + bounds.width / 2;
      const originY = bounds.top + bounds.height / 2;
      for (let index = 0; index < 18; index += 1) {
        const particle = document.createElement('span');
        const pumpkin = index % 6 === 0;
        const angle = Math.random() * Math.PI * 2;
        const distance = 55 + Math.random() * 95;
        particle.className = `coming-soon-particle${pumpkin ? ' coming-soon-particle--pumpkin' : ''}`;
        if (pumpkin) particle.textContent = '🎃';
        particle.setAttribute('aria-hidden', 'true');
        particle.style.left = `${originX}px`;
        particle.style.top = `${originY}px`;
        particle.style.setProperty('--particle-x', `${Math.cos(angle) * distance}px`);
        particle.style.setProperty('--particle-y', `${Math.sin(angle) * distance - 30}px`);
        particle.style.setProperty('--particle-spin', `${-240 + Math.random() * 480}deg`);
        particle.style.setProperty('--particle-duration', `${720 + Math.random() * 420}ms`);
        particle.style.setProperty('--particle-size', `${12 + Math.random() * 8}px`);
        document.body.appendChild(particle);
        particle.addEventListener('animationend', () => particle.remove(), { once: true });
      }
    });
  }

  const initializeAll = (root = document) => root.querySelectorAll('[data-coming-soon]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
